export default function getChildrenNavigationCache(navigation) {
  if (!navigation) {
    return {};
  }

  var childrenNavigationCache = navigation._childrenNavigation || (navigation._childrenNavigation = {});
  var childKeys = navigation.state.routes.map(function (route) {
    return route.key;
  });
  Object.keys(childrenNavigationCache).forEach(function (cacheKey) {
    if (!childKeys.includes(cacheKey) && !navigation.state.isTransitioning) {
      delete childrenNavigationCache[cacheKey];
    }
  });
  return navigation._childrenNavigation;
}